import type { SerializedError } from '@reduxjs/toolkit'
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query'

export const formatError = (err: FetchBaseQueryError | SerializedError) => {
  /**
   * Bug in RTK Query — the real error is sometimes nested under .error.
   * @see https://github.com/reduxjs/redux-toolkit/issues/3789
   *
   * Only unwrap when .error is itself a non-null object: FetchBaseQueryError
   * variants FETCH_ERROR / PARSING_ERROR / TIMEOUT_ERROR / CUSTOM_ERROR all
   * carry `error: string`, and unwrapping those produced TypeError on the
   * downstream `'status' in error` check (or returned the wrong copy).
   */
  const inner = (err as { error?: unknown }).error
  const error =
    inner && typeof inner === 'object' ? (inner as FetchBaseQueryError | SerializedError) : err
  if ('status' in error) {
    switch (error.status) {
      case 401:
        return 'You do not have access to this page'
      case 403:
        return 'Forbidden'
      case 404:
        return 'Page not found'

      case 'FETCH_ERROR':
        return 'Network error'
      case 'PARSING_ERROR':
        return 'Invalid data received'
      case 'TIMEOUT_ERROR':
        return 'Request timed out'

      default:
        return 'An unknown error occurred'
    }
  }
  return error.message ?? 'An unknown error occurred'
}
